module.exports = __webpack_public_path__ + "static/media/Taylor_Swift.0693e840.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Taylor_Swift.jpg
// module id = 415
// module chunks = 0